import { Modal } from "@shared/modal";

import { ConfigurationDetails } from "./configuration-details";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const ConfigurationModal = ({ isOpen, onClose }: Props) => (
  <Modal
    size="xl"
    isOpen={isOpen}
    onClose={onClose}
    titleContent={
      <div className="font-bold text-xl">Configuration Details</div>
    }
  >
    <ConfigurationDetails />
  </Modal>
);
